import { Component, inject } from '@angular/core';
import { AuthService, UserInformation } from '@shared/util-auth';
import { MenuItem } from 'primeng/api';
import { ClientConfigStore, UserStore } from '@shared/data';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.scss',
  standalone: false
})
export class UserComponent {
  user: UserInformation = {};
  menuItems?: MenuItem[];

  private authService = inject(AuthService);
  private userStore = inject(UserStore);
  private clientConfigStore = inject(ClientConfigStore);
  isLicoOrigin = this.clientConfigStore.isLicoOrigin;

  name = this.userStore.name;
  username = this.userStore.username;

  public logout(): void {
    this.authService.logout();
  }
}
